import { HEADER_TEXTS_ALIGN } from 'helpers/constants';
import { addEventEnabled, isDefined } from 'helpers/commons';
import { configureView } from 'helpers/viewConfig';

export const updateHeader = (current, updates, updateNeeded) => {
	const isCustomViewEnabled = current.addons.find(addon => addon.name === 'custom_view');
	const { numbers, booleans } = updates;
	if (updateNeeded.booleans) {
		if (isDefined(booleans.hideAgendaHeader))
			current.headerTitlesHidden.agenda = !booleans.hideAgendaHeader;
		if (isDefined(booleans.hideTimelineHeader))
			current.headerTitlesHidden.timeline = !booleans.hideTimelineHeader;
		if (isDefined(booleans.hideCardHeader))
			current.headerTitlesHidden.card = !booleans.hideCardHeader;
		if (isDefined(booleans.hideListHeader))
			current.headerTitlesHidden.list = !booleans.hideListHeader;
		if (isDefined(booleans.hideYearHeader))
			current.headerTitlesHidden.year = !booleans.hideYearHeader;
		if (isDefined(booleans.hideCrossHeader))
			current.headerTitlesHidden.cross = !booleans.hideCrossHeader;
		if (isDefined(booleans.hideCustomViewHeader))
			current.headerTitlesHidden.customView = !booleans.hideCustomViewHeader;
		if (isDefined(booleans.hideMonthlyHeader))
			current.headerTitlesHidden.month = !booleans.hideMonthlyHeader;
		if (isDefined(booleans.hideWeeklyDailyHeader))
			current.headerTitlesHidden.weekDay = !booleans.hideWeeklyDailyHeader;
		if (isDefined(booleans.hideMapHeader))
			current.headerTitlesHidden.map = !booleans.hideMapHeader;
		if (isDefined(booleans.showViews)) current.headerButtonsDisabled.all = !booleans.showViews;
		if (isDefined(booleans.hideMonth))
			current.headerButtonsDisabled.month = !booleans.hideMonth;
		if (isDefined(booleans.hideYear)) current.headerButtonsDisabled.year = !booleans.hideYear;
		if (isDefined(booleans.hidePrev)) current.headerButtonsDisabled.prev = !booleans.hidePrev;
		if (isDefined(booleans.hideNext)) current.headerButtonsDisabled.next = !booleans.hideNext;
		if (isDefined(booleans.hideAgendaWeek))
			current.headerButtonsDisabled.week = !booleans.hideAgendaWeek;
		if (isDefined(booleans.hideAgendaDay))
			current.headerButtonsDisabled.day = !booleans.hideAgendaDay;
		if (isDefined(booleans.hideUpcomingEvents))
			current.headerButtonsDisabled.agenda = !booleans.hideUpcomingEvents;
		if (isDefined(booleans.hideGrid)) current.headerButtonsDisabled.card = !booleans.hideGrid;
		if (isDefined(booleans.hideMap)) current.headerButtonsDisabled.map = !booleans.hideMap;
		if (isDefined(booleans.hideCross))
			current.headerButtonsDisabled.cross = !booleans.hideCross;
		if (isDefined(booleans.hideCustomView))
			current.headerButtonsDisabled.customView =
				!booleans.hideCustomView || !isCustomViewEnabled;
		if (isDefined(booleans.hideList)) current.headerButtonsDisabled.list = !booleans.hideList;
		if (isDefined(booleans.hideTimeline))
			current.headerButtonsDisabled.timeline = !booleans.hideTimeline;
		if (isDefined(booleans.hideToday))
			current.headerButtonsDisabled.today = !booleans.hideToday;
		if (isDefined(booleans.showSearch))
			current.headerButtonsDisabled.search = !booleans.showSearch;
		current.headerButtonsDisabled.addEvent = !addEventEnabled(current.addons, 'button');
		if (isDefined(booleans.printButton))
			current.headerButtonsDisabled.print = !booleans.printButton;
	}

	const isAddEventEnabled = isDefined(booleans.addEventEnabled) ? booleans.addEventEnabled : true;
	const isAddEventButton = isDefined(booleans.addEventButton) ? booleans.addEventButton : true;

	current.headerButtonsDisabled.addEventButton = !isAddEventEnabled ? true : !isAddEventButton;

	if (updateNeeded.numbers) {
		if (isDefined(numbers.headerDateAlign))
			current.headerTextsAlign = HEADER_TEXTS_ALIGN[numbers.headerDateAlign];
	}
	let { header } = configureView({
		activeView: null,
		currentView: current.currentView,
		temporaryView: current.temporaryView,
		showHours: current.weekDaySpecifics.showHours,
		isMobile: current.isMobile,
		headerTextsAlign: current.headerTextsAlign,
		headerButtonsDisabled: current.headerButtonsDisabled,
		headerTitlesHidden: current.headerTitlesHidden,
		categories: current.categories,
		listViewType: current.listSpecifics.type,
		yearViewStyle: current.yearlySpecifics.style,
		showCategoryBlock: current.showCategoryBlock,
		crossViewStyle: current.crossSpecifics.crossStyle
	});
	current.header = header;
};

export const processCustomTitles = (currents, updates) => {
	return {
		agenda: updates.headerText ?? currents.agenda,
		card: updates.gridText ?? currents.card,
		map: updates.mapText ?? currents.map,
		cross: updates.crossText ?? currents.cross,
		customView: updates.customViewText ?? currents.customView,
		timeline: updates.timelineText ?? currents.timeline
	};
};

export const processNavButtonsTexts = (currents, updates) => {
	if (!updates) return currents;
	return {
		prev: updates.leftButtonText ?? currents.prev,
		next: updates.rightButtonText ?? currents.next,
		month: updates.monthButtonText ?? currents.month,
		week: updates.weekButtonText ?? currents.week,
		day: updates.dayButtonText ?? currents.day,
		agenda: updates.agendaButtonText ?? currents.agenda,
		map: updates.MapButtonText ?? currents.map,
		card: updates.gridButtonText ?? currents.card,
		list: updates.listButtonText ?? currents.list,
		today: updates?.todayButtonText,
		year: updates.yearButtonText ?? currents.year,
		cross: updates.crossButtonText ?? currents.cross,
		timeline: updates.timelineButtonText ?? currents.timeline,
		customView: updates.customViewButtonText ?? currents.customView
	};
};
